import axios, { buildApi } from '@/libs/api.request';
let name = '/tracker/vacation'

export const apis = buildApi({
  get: [name + '/index&list',],
  post: [name + '/save', name + '/delete/:id&del']
})